// components/ShowIf.js
import usePermission from "../Util/usePermissions";

export default function ShowIf({
    permission,
    any,
    all,
    role,
    children,
    condition,
    fallback = null,
}) {
    const { hasPermission, hasAnyPermission, hasAllPermissions, hasRole } =
        usePermission();

    let allowed = true;

    if (permission) allowed = allowed && hasPermission(permission);
    if (any) allowed = allowed && hasAnyPermission(any);
    if (all) allowed = allowed && hasAllPermissions(all);
    if (role) allowed = allowed && hasRole(role);
    if (condition !== undefined) allowed = allowed && condition;

    return allowed ? children : fallback;
}
